import { render } from "./MyEvaluation.vue?vue&type=template&id=0dea7272&scoped=true"
import script from "./MyEvaluation.vue?vue&type=script&lang=js"
export * from "./MyEvaluation.vue?vue&type=script&lang=js"

import "./MyEvaluation.vue?vue&type=style&index=0&id=0dea7272&lang=scss&scoped=true"

import exportComponent from "C:\\developmentGIT\\Pirca\\PircaSolutions.Forge\\PircaSolutions.Forge.AccessIntegrationSite\\access-integration\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0dea7272"]])

export default __exports__